import { render, staticRenderFns } from "./WaitingForCreateOrder.vue?vue&type=template&id=49d73db7"
import script from "./WaitingForCreateOrder.vue?vue&type=script&lang=js"
export * from "./WaitingForCreateOrder.vue?vue&type=script&lang=js"
import style0 from "./WaitingForCreateOrder.vue?vue&type=style&index=0&id=49d73db7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports